module.exports = __webpack_public_path__ + "img/Asset190.3668c838.svg";